import * as t from 'io-ts';

import { valuesOf } from '@transcend-io/type-utils';

import { AnalyticsDataSource } from '@main/analytics-types';
import { dbModelId } from '@main/schema-utils';

export const AnalyticsChartBlockConfig = t.union([
  t.literal('none'),
  dbModelId('organization'),
]);

/**
 * Type override
 */
export type AnalyticsChartBlockConfig = t.TypeOf<
  typeof AnalyticsChartBlockConfig
>;

/**
 * A mapping of chart keys to their configuration
 * -- if the value is 'none', then NO organizations are allowed
 * -- if the value is an array of strings, then only organizations with those IDs are blocked
 * -- if the code is missing from the config override, then it is allowed for ALL orgs
 *
 * I literally just copied Minh's homework on this with how she did Action Items,
 * but inverted the logic
 *
 * @example
 * { 'FULFILLMENT_TIME_BY_REQUEST': 'none', 'AVERAGE_FULFILLMENT_TIME': ['org1', 'org2'] }
 */
export const AnalyticsChartBlockList = t.union([
  t.partial({}),
  t.record(valuesOf(AnalyticsDataSource), AnalyticsChartBlockConfig),
]);

/**
 * Type override
 */
export type AnalyticsChartBlockList = t.TypeOf<typeof AnalyticsChartBlockList>;
